import React, { useRef } from 'react';
import { UploadIcon } from '../icons';

const ALLOWED_EXT = ['.pdf', '.docx', '.doc', '.html', '.htm', '.txt', '.md', '.pptx', '.xlsx'];

export default function FileUploadMode({ uploading, uploadStatus, uploadErrors, onFilesSelected }) {
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const rawFiles = Array.from(e.target.files || []);
    if (fileInputRef.current) fileInputRef.current.value = '';
    onFilesSelected(rawFiles);
  };

  return (
    <div className="doc-mode-area">
      <button
        className="doc-file-trigger"
        onClick={() => fileInputRef.current?.click()}
        disabled={uploading}
      >
        {uploading && uploadStatus
          ? `${uploadStatus.fileIndex}/${uploadStatus.fileCount} — ${uploadStatus.pct}%`
          : <><UploadIcon /> Choose files…</>}
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept={ALLOWED_EXT.join(',')}
        multiple
        style={{ display: 'none' }}
        onChange={handleChange}
      />
      {uploading && uploadStatus && (
        <div className="documents-progress-bar">
          <div className="documents-progress-fill" style={{ width: `${uploadStatus.pct}%` }} />
        </div>
      )}
      {uploadErrors.length > 0 && (
        <div className="documents-error">
          {uploadErrors.map((e, i) => (
            <div key={i}><strong>{e.filename}</strong>: {e.error}</div>
          ))}
        </div>
      )}
    </div>
  );
}
